<template>
   <div :inert="isModal || isDeleteModal" aria-hidden="isModal || isDeleteModal">
    <div class="flex flex-wrap gap-3 px-4 mb-4 justify-end items-center">
      <SearchInput @search-select="handleSearchSelect" @results="handleSearchResults" @clear="handleSearchClear" />
            <button @click="createModal"
        class="bg-primary-button hover:bg-primary-button-hover text-white ml-3 px-4 py-2 rounded transition-all duration-200 text-sm">
        + Bayi Ekle
      </button>
    </div>
    <div
      class="overflow-hidden rounded-md border border-light-border dark:border-dark-border bg-primary-bg dark:bg-primary-dark-bg pb-3 shadow-md">
      <div class="w-full overflow-x-auto">
        <table class="min-w-full text-left text-sm text-secondary-text dark:text-gray-300">
          <thead class=" bg-gray-100 dark:bg-gray-800 font-medium">
            <tr>
              <th class="px-3 md:px-6 py-2 md:py-4">Bayi Adı</th>
              <th class="px-3 md:px-6 py-2 md:py-4">Bayi Durum</th>
              <th class="px-3 md:px-6 py-2 md:py-4">İşlemler</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dealer in dealers" :key="dealer.dealer_id"
              class="border-b transition hover:light-hover dark:hover:dark-hover">
              <td class="px-3 md:px-6 py-2 md:py-4 font-medium text-primary-text dark:text-gray-100 ">
                {{ dealer.dealer_name }}
              </td>
              <td class="px-3 md:px-6 py-2 md:py-4">
                <span :class="{
                  'px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800 dark:bg-green-200 dark:text-green-900': dealer.dealer_status === 1,
                  'px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800 dark:bg-red-200 dark:text-red-900': dealer.dealer_status === 0
                }">
                  {{ dealer.dealer_status === 1 ? 'Aktif' : 'Pasif' }}
                </span>
              </td>
              <td class="px-3 md:px-6 py-2 md:py-4 flex gap-2">
                <button @click="editModal(dealer)" class="relative group">
                  <PencilSquareIcon
                    class="w-5 h-5 text-gray-500 hover:text-secondary-text dark:text-gray-300 dark:hover:text-white" />
                  <span
                    class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">Düzenle</span>
                </button>
                 <button @click="deleteModal(dealer)" class="relative group">
                  <TrashIcon class="w-5 h-5 text-red-500 hover:text-red-600" />
                  <span
                    class="absolute -top-8 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition bg-black text-white text-xs px-2 py-1 rounded">Sil</span>
                </button> 
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <AppPagination v-if="!searchActive" :currentPage="currentPage" :totalPages="totalPages" @prev-page="currentPage--"
        @next-page="currentPage++" @go-to-page="page => currentPage = page"
         @update:pageSize="handlePageSizeChange"
        :pageSize="pageSize"/>
    </div>
  </div>

    <CompanyModal v-if="isModal" :form="form" :fields="fields" :mode="modalMode" :loading="loading"
      @close="isModal = false" @submit="handleSubmit" @update:form="form = $event" />

     <DeleteModal v-if="isDeleteModal" :item="selectedDealer" message="Bu bayiyi silmek istediğinizden emin misiniz?"
      @close="isDeleteModal = false" @confirm-delete="handleDelete" @click.self="isDeleteModal = false" /> 
</template>

<script>
import { postApi, getApi, putApi, deleteApi } from "@/services/api";
import CompanyModal from '@/components/Modals/CompanyModal.vue';
import DeleteModal from '@/components/Modals/DeleteModal.vue';
import { PencilSquareIcon, TrashIcon } from '@heroicons/vue/24/outline';
import SearchInput from '@/components/SearchInput.vue'

export default {
  name: "AllCompany",
  components: {
    PencilSquareIcon,
    TrashIcon,
    CompanyModal,
    DeleteModal,
    SearchInput
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 50,
      totalDealersCount: 0,
      searchActive: false,
      modalMode: 'create',
      selectedDealer: null,
      isDeleteModal: false,
      isModal: false,
      loading: false,
      dealers: [],
      form: {
        dealer_name: '',
        dealer_address: '',
        shipment_address: '',
        dealer_tel: '',
        dealer_official: '',
        dealer_status: 1
      },
      fields: {
        dealer_name: 'Bayi Adı',
        dealer_address: 'Bayi Adres',
        shipment_address: 'Sevk Yeri',
        dealer_tel: 'Bayi Telefon',
        dealer_official: 'Bayi Yetkili'
      },
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalDealersCount / this.pageSize);
    }
  },
  methods: {
    async fetchDealers() {
      if (this.searchActive) return; // avoid overriding active search results
      const take = this.pageSize;
      const skip = (this.currentPage - 1) * this.pageSize;

      try {
        const response = await getApi(`/dealers/${take}/${skip}`);

        this.dealers = response.dealers || [];

        this.totalDealersCount = response.total_result || 0;
      } catch (error) {
        this.$toast.error("Bayiler alınırken hata oluştu!");
      }
    },


    createModal() {
      this.modalMode = 'create';
      this.resetForm();
      this.isModal = true;
    },

    editModal(dealer) {
      this.modalMode = 'edit';
      this.form = { ...dealer };
      this.isModal = true;
    },

    deleteModal(dealer) {
      this.selectedDealer = dealer;
      this.isDeleteModal = true;
    },

    resetForm() {
      this.form = {
        dealer_name: '',
        dealer_address: '',
        shipment_address: '',
        dealer_tel: '',
        dealer_official: '',
        dealer_status: 1
      };
      this.loading = false;
    },

    async handleSubmit() {
      if (this.loading) return;
      this.loading = true;
      try {
        const payload = {
          dealer_name: this.form.dealer_name,
          dealer_address: this.form.dealer_address,
          dealer_tel: this.form.dealer_tel,
          dealer_official: this.form.dealer_official,
          shipment_address: this.form.shipment_address,
          dealer_status: parseInt(this.form.dealer_status),
        };
        if (this.modalMode === 'create') {
          await postApi('/dealers/', payload);
          this.$toast.success("Bayi başarıyla eklendi!");
        } else if (this.modalMode === 'edit' && this.form.dealer_id) {
          await putApi(`/dealers/${this.form.dealer_id}`, payload);
          this.$toast.success("Bayi başarıyla güncellendi!");
        }
        this.fetchDealers();
        this.isModal = false;
      } catch (error) {
        this.$toast.error("Bir hata oluştu!");
      } finally {
        this.loading = false;
      }
    },

    async handleDelete(dealer) {
      try {
        await deleteApi(`/dealers/${dealer.dealer_id}`);
        this.$toast.success("Bayi başarıyla silindi!");
        this.fetchDealers();
      } catch (error) {
        this.$toast.error("Silme işlemi sırasında hata oluştu!");
      } finally {
        this.isDeleteModal = false;
      }
    },
    async handleSearchSelect(dealer) {
      this.searchActive = true;
      this.dealers = [dealer];
      this.totalDealersCount = 1;
      this.currentPage = 1;
    },
    handleSearchResults(results) {
      this.searchActive = true;
      this.dealers = Array.isArray(results) ? results : [];
      this.totalDealersCount = this.dealers.length;
      this.currentPage = 1;
    },
    handleSearchClear() {
      this.searchActive = false;
      this.currentPage = 1;
      this.fetchDealers();
    },
    
    handlePageSizeChange(newPageSize) {
      this.pageSize = newPageSize;
      this.currentPage = 1; 
      this.fetchDealers();
    },
  },
  mounted() {
    this.fetchDealers();
  },
  watch: {
    currentPage() {
      if (!this.searchActive) this.fetchDealers();
    },
    pageSize() {
      this.currentPage = 1;
      if (!this.searchActive) this.fetchDealers();
    }
  }
};
</script>
